/* eslint-disable arrow-body-style */
import { EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiTitle } from "@elastic/eui";
import React from "react";

const SummarySection = ({ item, isLastSection }) => {
    return (
        <EuiFlexGroup
            key={item?.id}
            direction="column"
            gutterSize="m"
        >
            <EuiFlexGroup
                key={item?.id}
                justifyContent="spaceBetween"
                gutterSize="s"
            >
                <EuiFlexItem grow={4}>
                    <EuiTitle
                        size="xs"
                        fontWeight="normal"
                        style={{ color: "#6B7280", fontWeight: "normal" }}
                    >
                        <h3>{item?.title}</h3>
                    </EuiTitle>
                </EuiFlexItem>
                <EuiFlexItem grow={1}>
                    <EuiTitle size="xs">
                        <span>{item?.value}</span>
                    </EuiTitle>
                </EuiFlexItem>
            </EuiFlexGroup>
            {!isLastSection && <EuiHorizontalRule />}
        </EuiFlexGroup>
    );
};

export default SummarySection;
